import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateVehicleCategoryComponent = loadable(
  () => import("../../components/VehicleCategory/CreateVehicleCategory")
);
const CreateVehicleCategory = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["vehicle-category"],
    navigateURL: "/vehicle-category",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.VEHILCE_CATEGORY}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Vehicle Category
        </span>
      </div>
      <CreateVehicleCategoryComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateVehicleCategory;
